import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "reduxUtils/store";

export const selectCurrentAccount = (state: RootState) => state.currentAccount;

export const selectIsAccountActive = createSelector(
  selectCurrentAccount,
  (currentAccount) => {
    return currentAccount.active;
  },
);
